import React, { useState, useEffect } from 'react'
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'
import { GetTombolaConfig, GetContactoConfig, GetPortadaConfig, GetSoporteConfig, GetCumpleanosConfig } from './../../utilities/BL/Tombola'
import { GetLogoConfig } from './../../utilities/BL/Logo'
import { GetMencionesConfig } from './../../utilities/DL/Menciones'
import { GetPreguntasConfig } from './../../utilities/DL/Preguntas'
import { GetPremiosConfig } from './../../utilities/DL/Premios'
import { Tombola as TombolaOverlay } from './Overlays/Tombola'
import { Contacto as ContactoOverlay } from './Overlays/Contacto'
import { Portada as PortadaOverlay } from './Overlays/Portada'
import { Soporte as SoporteOverlay } from './Overlays/Soporte'
import { Cumpleanos as CumpleanosOverlay } from './Overlays/Cumpleanos'
import { MencionesOverlay } from './Overlays/MencionesOverlay'
import { PreguntasOverlay } from './Overlays/PreguntasOverlay'
import { PremiosOverlay } from './Overlays/PremiosOverlay'
import LogoOverlay from './Overlays/LogoOverlay'

/**
 * COMPONENTE: Tombola OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * 1. Establece la conexión WebSocket como "overlay:tombola".
 * 2. Carga la configuración inicial de Insignia, Contacto y Portada.
 * 3. Escucha mensajes WebSocket en tiempo real para todos los elementos.
 * 4. Renderiza los overlays en paralelo.
 * ------------------------------------------------------------------
 */
const Tombola = () => {
    // Estado de Insignia (En vivo)
    const [config, setConfig] = useState({
        text: 'EN VIVO',
        visible: true,
        expanded: false,
        designStyle: 'simple',
        logoDataUrl: null,
        scale: 1.0,
        speed: 1.5,
        position: 'center',
        color: '#ff003c',
        glow: 12,
        offsetX: 0,
        offsetY: 0
    });

    // Estado de Contacto (WhatsApp)
    const [contactConfig, setContactConfig] = useState({
        topText: 'Envía tu mensaje de voz al:',
        phoneNumber: '000 - 111 - 01 - 01',
        bottomText: 'Powered by Interaktia',
        visible: true,
        expanded: false,
        position: 'center',
        offsetX: 510,
        offsetY: 825,
        bgType: 'color',
        bgColor: '#b3001e',
        bgMediaUrl: null,
        innerBgColor: '#ffffff',
        innerTextColor: '#000000',
        borderColor: '#ffffff',
        borderWidth: 2,
        iconBgColor: '#25d366',
        iconSymbolColor: '#ffffff',
        iconDataUrl: null,
        iconZoom: 1.0,
        scale: 1.0
    });

    // Estado de Portada
    const [portadaConfig, setPortadaConfig] = useState({
        titleText: 'LA TÓMBOLA PERRONA',
        subtitleText: '',
        visible: false,
        expanded: false,
        bgType: 'video',
        bgColor: '#b3001e',
        bgMediaUrl: '/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4',
        logoDataUrl: null,
        logoScale: 1.0,
        logoOffsetX: 0,
        logoOffsetY: 0,
        titleImgDataUrl: null,
        titleImgWidth: 500,
        titleImgScale: 1.0,
        titleOffsetX: 0,
        titleOffsetY: 0,
        titleSize: 4.8,
        subtitleSize: 2.2,
        showIcon: true,
        scale: 1.0
    });

    // Estado de Soporte (Detalles Técnicos)
    const [soporteConfig, setSoporteConfig] = useState({
        titleText: 'DETALLES TÉCNICOS',
        titleColor: '#ffaa00',
        titleSize: 2.0,
        titleOffsetX: 0,
        titleOffsetY: -80,
        descriptionText: 'Estamos experimentando dificultades técnicas. Volveremos en breve, gracias por tu paciencia.',
        descriptionColor: '#94a3b8',
        descSize: 1.0,
        descOffsetX: 0,
        descOffsetY: 50,
        accentScale: 1.0,
        accentOffsetX: 0,
        accentOffsetY: -220,
        visible: false,
        expanded: false,
        bgColor: '#151620',
        scale: 1.0,
        speed: 1.8,
        color: '#ffaa00',
        glow: 30,
        position: 'center',
        offsetX: 960,
        offsetY: 540
    });

    // Estado de Cumpleaños
    const [cumpleanosConfig, setCumpleanosConfig] = useState({
        visible: false,
        expanded: false,
        titleText: 'Felicidades',
        namesJson: '[]',
        scale: 1.0,
        position: 'center',
        offsetX: 50,
        offsetY: 85,
        fontFamily: 'Montserrat',
        titleColor: '#ffffff',
        nameColor: '#ffffff',
        bgColor: '#ff003c',
        fontSizeTitle: 2.0,
        fontSizeName: 3.2,
        logoLeftDataUrl: null,
        logoRightDataUrl: null,
        showConfetti: true,
        confettiOpacity: 0.8,
        rotationSpeed: 5,
        activeName: '',
    });

    // Estado de Menciones
    const [mencionesConfig, setMencionesConfig] = useState({
        visible: false,
        scale: 1.0,
        logoScale: 1.0,
        logoRightScale: 1.0,
        elementSpacing: 24,
        position: 'center',
        offsetX: 50,
        offsetY: 85,
        fontFamily: 'Montserrat',
        titleColor: '#ffffff',
        textColor: '#ffffff',
        bgColor: '#ff003c',
        menciones: [],
        activeMencion: null,
        isVertical: false
    });

    // Estado de Preguntas
    const [preguntasConfig, setPreguntasConfig] = useState({
        visible: false,
        scale: 1.0,
        logoDataUrl: null,
        position: 'center',
        offsetX: 50,
        offsetY: 85,
        fontFamily: 'Montserrat',
        titleColor: '#ffffff',
        textColor: '#ffffff',
        bgColor: '#ff003c',
        preguntas: [],
        activePregunta: null
    });

    // Estado de Premios
    const [premiosConfig, setPremiosConfig] = useState({
        visible: false,
        scale: 1.0,
        logoDataUrl: null,
        position: 'center',
        offsetX: 50,
        offsetY: 85,
        fontFamily: 'Montserrat',
        titleColor: '#ffffff',
        textColor: '#ffffff',
        bgColor: '#ff003c',
        premios: [],
        activePremio: null
    });

    // Estado de Logotipo
    const [logoConfig, setLogoConfig] = useState({
        logoDataUrl: null,
        visible: false,
        scale: 1.0,
        orientation: 'horizontal',
        position: 'top-right',
        offsetX: 90,
        offsetY: 8
    });
    
    const [connectionStatus, setConnectionStatus] = useState('idle');
    const [windowScale, setWindowScale] = useState(1);

    // Ajustar el lienzo general de 1920x1080 para que quepa en el viewport actual
    useEffect(() => {
        const handleResize = () => {
            const scaleX = window.innerWidth / 1920;
            const scaleY = window.innerHeight / 1080;
            setWindowScale(Math.min(scaleX, scaleY));
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Forzar fondo transparente y eliminar barras de desplazamiento para OBS
    useEffect(() => {
        const originalBodyBg = document.body.style.backgroundColor;
        const originalHtmlBg = document.documentElement.style.backgroundColor;
        const originalBodyOverflow = document.body.style.overflow;
        const originalHtmlOverflow = document.documentElement.style.overflow;
        const rootElement = document.getElementById('root');

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
            rootElement.style.overflow = 'hidden';
        }

        return () => {
            document.body.style.backgroundColor = originalBodyBg;
            document.documentElement.style.backgroundColor = originalHtmlBg;
            document.body.style.overflow = originalBodyOverflow;
            document.documentElement.style.overflow = originalHtmlOverflow;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
                rootElement.style.removeProperty('overflow');
            }
        };
    }, []);

    // Conexión y sincronización
    useEffect(() => {
        const connect = async () => {
            // 1. Obtener la configuración guardada del backend (Insignia)
            const res = await GetTombolaConfig();
            if (res.success && res.data) {
                setConfig(prev => ({ ...prev, ...res.data }));
            }

            // 2. Obtener la configuración guardada de Contacto
            const resContact = await GetContactoConfig();
            if (resContact.success && resContact.data) {
                setContactConfig(prev => ({ ...prev, ...resContact.data }));
            }

            // 3. Obtener la configuración guardada de Portada
            const resPortada = await GetPortadaConfig();
            if (resPortada.success && resPortada.data) {
                setPortadaConfig(prev => ({ ...prev, ...resPortada.data }));
            }

            // 3b. Obtener la configuración guardada de Soporte
            const resSoporte = await GetSoporteConfig();
            if (resSoporte.success && resSoporte.data) {
                setSoporteConfig(prev => ({ ...prev, ...resSoporte.data }));
            }

            // 3c. Obtener la configuración de Cumpleaños
            const resCumpleanos = await GetCumpleanosConfig();
            if (resCumpleanos.success && resCumpleanos.data) {
                setCumpleanosConfig(prev => ({ ...prev, ...resCumpleanos.data }));
            }

            // 3d. Obtener la configuración de Menciones
            const resMenciones = await GetMencionesConfig();
            if (resMenciones.success && resMenciones.data) {
                setMencionesConfig(prev => ({ ...prev, ...resMenciones.data }));
            }

            // 3e. Obtener la configuración de Preguntas
            const resPreguntas = await GetPreguntasConfig();
            if (resPreguntas.success && resPreguntas.data) {
                setPreguntasConfig(prev => ({ ...prev, ...resPreguntas.data }));
            }

            // 3f. Obtener la configuración de Premios
            const resPremios = await GetPremiosConfig();
            if (resPremios.success && resPremios.data) {
                setPremiosConfig(prev => ({ ...prev, ...resPremios.data }));
            }

            // 3g. Obtener la configuración de Logotipo
            const resLogo = await GetLogoConfig();
            if (resLogo.success && resLogo.data) {
                setLogoConfig(prev => ({ ...prev, ...resLogo.data }));
            }

            // 4. Conectar WebSocket a la sala común de tombola
            await ConnectWebSocketForOverlay(
                'tombola',
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Overlay Tombola & Contacto] WS status:', msg)
            );

            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            const msgType = message.type.toLowerCase();
            const payload = message.data;

            // Enrutamiento WebSocket para Insignia
            if (msgType === 'tombola') {
                if (payload.action === 'config') {
                    setConfig(prev => ({ ...prev, ...payload.config }));
                } else if (payload.action === 'show') {
                    setConfig(prev => ({ ...prev, visible: true }));
                } else if (payload.action === 'hide') {
                    setConfig(prev => ({ ...prev, visible: false }));
                }
            }
            
            // Enrutamiento WebSocket para Contacto
            if (msgType === 'contacto') {
                if (payload.action === 'config') {
                    setContactConfig(prev => ({ ...prev, ...payload.config }));
                } else if (payload.action === 'show') {
                    setContactConfig(prev => ({ ...prev, visible: true }));
                } else if (payload.action === 'hide') {
                    setContactConfig(prev => ({ ...prev, visible: false }));
                }
            }

            // Enrutamiento WebSocket para Portada
            if (msgType === 'portada') {
                if (payload.action === 'config') {
                    setPortadaConfig(prev => ({ ...prev, ...payload.config }));
                } else if (payload.action === 'show') {
                    setPortadaConfig(prev => ({ ...prev, visible: true }));
                } else if (payload.action === 'hide') {
                    setPortadaConfig(prev => ({ ...prev, visible: false }));
                }
            }

            // Enrutamiento WebSocket para Soporte
            if (msgType === 'soporte') {
                if (payload.action === 'config') {
                    setSoporteConfig(prev => ({ ...prev, ...payload.config }));
                } else if (payload.action === 'show') {
                    setSoporteConfig(prev => ({ ...prev, visible: true }));
                } else if (payload.action === 'hide') {
                    setSoporteConfig(prev => ({ ...prev, visible: false }));
                }
            }

            // Enrutamiento WebSocket para Cumpleaños
            if (msgType === 'cumpleanos') {
                if (payload.action === 'config') {
                    setCumpleanosConfig(prev => ({ ...prev, ...payload.config }));
                } else if (payload.action === 'show') {
                    setCumpleanosConfig(prev => ({ ...prev, visible: true }));
                } else if (payload.action === 'hide') {
                    setCumpleanosConfig(prev => ({ ...prev, visible: false }));
                }
            }

            // Enrutamiento WebSocket para Menciones
            if (msgType === 'menciones') {
                if (payload.action === 'config') {
                    setMencionesConfig(prev => ({ ...prev, ...payload.config }));
                }
            }

            // Enrutamiento WebSocket para Preguntas
            if (msgType === 'preguntas') {
                if (payload.action === 'config') {
                    setPreguntasConfig(prev => ({ ...prev, ...payload.config }));
                }
            }

            // Enrutamiento WebSocket para Premios
            if (msgType === 'premios') {
                if (payload.action === 'config') {
                    setPremiosConfig(prev => ({ ...prev, ...payload.config }));
                }
            }

            // Enrutamiento WebSocket para Logo
            if (msgType === 'logo') {
                if (payload.action === 'config') {
                    setLogoConfig(prev => ({ ...prev, ...payload.config }));
                } else if (payload.action === 'show') {
                    setLogoConfig(prev => ({ ...prev, visible: true }));
                } else if (payload.action === 'hide') {
                    setLogoConfig(prev => ({ ...prev, visible: false }));
                }
            }
        };

        connect();
        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    return (
        <>
            <PortadaOverlay config={portadaConfig} windowScale={windowScale} />
            <SoporteOverlay config={soporteConfig} windowScale={windowScale} />
            <TombolaOverlay config={config} />
            <ContactoOverlay config={contactConfig} />
            <CumpleanosOverlay config={cumpleanosConfig} />
            <MencionesOverlay config={mencionesConfig} />
            <PreguntasOverlay config={preguntasConfig} />
            <PremiosOverlay config={premiosConfig} />
            <LogoOverlay config={logoConfig} windowScale={windowScale} />

            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: '#ef4444', color: 'white', padding: 4, fontSize: 8, zIndex: 9999 }}>
                    DISCONNECTED
                </div>
            )}
        </>
    );
};

export { Tombola };
